/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@paypalcorp/pp-react';
import ContactCardContainer from './ContactCardContainer';
import { iconSize } from '../../../lib/globalHelper';

/**
 * Re-usable Component for contact option card
 */
const ContactCardComponent = (props) => {
  const {
    contactSize, contactLabel, contactType, contactTarget, contactUrl, contactDescription,
  } = props;
  const contactClassName = `contact-icon--icon-${contactType}`;

  const icon = !contactClassName.includes('icon-message-center')
    ? <div className={`contact-card--contact-icon contact-card--${contactClassName}`} aria-hidden="true" />
    : (
      <Icon size={iconSize()} className="contact-card--contact-icon contact-card--contact-icon--icon-message-center" name="message-center" aria-hidden="true" />
    );
  return (
    <div className={`contact-card contact-card--sh-card-${contactSize}`} id={`new-hero-${contactType}-link`} onClick={(e) => ContactCardContainer.clickHandler(e, props)}>
      {icon}
      <div className="contact-card--label-description-icon-container">
        <div className="contact-card--contact-labels">
          <a
            rel="noopener noreferrer"
            href={contactUrl}
            target={contactTarget}
          >
            {contactLabel}
          </a>
        </div>
        <div className="contact-card--contact-description">
          {contactDescription}
        </div>

        <div className="contact-card--popup-icon" aria-hidden="true" />
      </div>
    </div>

  );
};

ContactCardComponent.propTypes = {
  contactLabel: PropTypes.string,
  contactDescription: PropTypes.string,
  contactType: PropTypes.string,
  contactTarget: PropTypes.string,
  contactUrl: PropTypes.string,
  contactSize: PropTypes.string,
};

ContactCardComponent.defaultProps = {
  contactSize: 'auto',
  contactLabel: '',
  contactDescription: '',
  contactType: '',
  contactTarget: '_self',
  contactUrl: '',
  contactNewTab: false,
};

export default ContactCardComponent;
